import { useEffect, useState } from 'react';
import {
  getActionsTerm,
  getCashDurationShortTerm,
  getCashDurationTerm,
  getCashMovementTerms,
  getCategoryLabel,
  getForecastTerm,
  getScenarioTerm,
  getVarianceTerm,
} from '@/lib/terminology-config';

/**
 * Subscribes to the `terminology-updated` window event and forces a re-render,
 * so every consumer reads fresh terminology values from sessionStorage.
 *
 * Returns pre-computed values for common getters plus pass-through references
 * for parameterised ones (getCashDurationTerm, getCategoryLabel, etc.).
 */
export function useTerminology() {
  const [, setVersion] = useState(0);

  useEffect(() => {
    const handler = () => setVersion((v) => v + 1);
    window.addEventListener('terminology-updated', handler);
    return () => window.removeEventListener('terminology-updated', handler);
  }, []);

  return {
    forecastTerm: getForecastTerm(),
    scenarioTerm: getScenarioTerm(),
    varianceTerm: getVarianceTerm(),
    actionsTerm: getActionsTerm(),
    cashMovementTerms: getCashMovementTerms(),
    cashDurationShortTerm: getCashDurationShortTerm(),
    getCashDurationTerm,
    getCategoryLabel,
    getForecastTerm,
    getScenarioTerm,
    getVarianceTerm,
    getActionsTerm,
    getCashMovementTerms,
    getCashDurationShortTerm,
  };
}
